import { doc, updateDoc } from 'firebase/firestore';
import { auth, db } from './firebase'
import { getUserData } from './getUserData';

//関数が呼び出された時にユーザー名を更新
export async function saveGetItem(inputItemIdArr) {
  try {
    const userRef = doc(db, 'users', auth.currentUser.uid)
    let itemListTmp = [];
    await getUserData().then((data) => {
      itemListTmp = data.itemList;
    });
    for (let i = 0; i < inputItemIdArr.length; i++) {
      if (itemListTmp.includes(inputItemIdArr[i])) continue;
      itemListTmp.push(inputItemIdArr[i]);
    }
    const data = {
      itemList: itemListTmp,
    }

    if (data.itemList) {
      await updateDoc(userRef, data);
      return "👍 : 正常に変更されました";
    }

  } catch (err) {
    console.error("Error adding document: ", err);
  }
}
